
import {
  Box,
  Flex,
  Grid,
  Text,
  Icon,
  Card,
  CardBody,
  Skeleton
} from "@chakra-ui/react";

import { LuCreditCard, LuFileText, LuInfo, LuMessageCircle, LuShield, LuTrendingUp } from 'react-icons/lu';

const TemplateManagerSstats = ({ stats }) => {
  if (!stats) {
    return (
      <div>
        <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6}>
          {[...Array(4)].map((_, i) => (
            <Box key={i} className="box-style-card">
              <Box p={1}>
                <Flex justify="space-between" align="center">
                  <Box flex={1}>
                    <Skeleton height="14px" width="60%" mb={2} />
                    <Skeleton height="32px" width="40%" />
                  </Box>
                  <Skeleton boxSize="24px" borderRadius="md" />
                </Flex>
              </Box>
            </Box>
          ))}
        </Grid>
        <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6}>
          {[...Array(4)].map((_, i) => (
            <Card key={i} boxShadow="sm" borderRadius="lg" border="1px solid" borderColor="gray.200">
              <CardBody py={5}>
                <Flex justify="space-between" align="flex-start">
                  <Box flex={1}>
                    <Skeleton height="14px" width="70%" mb={2} />
                       <Skeleton height="32px" width="40%" />
                  </Box>
                   <Skeleton boxSize="24px" borderRadius="md" />
                </Flex>
              </CardBody>
            </Card>
          ))}
        </Grid>
      </div>
    );
  }

  return (
    <div>
      {/* Top Summary Grid */}
      <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6}>

        <Box className='box-style-card'>
          <Box p={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Total Templates
                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.totalTemplates}
                </Text>
              </Box>
              <LuFileText  style={{ fontSize: "1.5rem", color: "#155dfc" }} />
            </Box>
          </Box>
        </Box>


        <Box className='box-style-card'>
          <Box p={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Active Templates

                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.activeTemplate}
                </Text>
              </Box>
              <LuShield  style={{ fontSize: "1.5rem", color: "#9810fa" }} />
            </Box>
          </Box>
        </Box>

        <Box className='box-style-card'>
          <Box p={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Total Usage

                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.totalUsage.toLocaleString()}
                </Text>
              </Box>
              <LuTrendingUp  style={{ fontSize: "1.5rem", color: "#9810fa" }} />
            </Box>
          </Box>
        </Box>
        <Box className='box-style-card'>
          <Box p={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Text fontSize="sm" color="gray.500">
                  Channels Supported

                </Text>
                <Text fontSize="2xl" fontWeight="semibold">
                  {stats?.channelSupport}
                </Text>
              </Box>
              <LuMessageCircle style={{ fontSize: "1.5rem", color: "#f54a00" }} />
            </Box>
          </Box>
        </Box>



      </Grid>

      {/* Template Categories */}
      <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6}>
        <Card bg="red.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="red.200" borderStyle="solid">
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuShield} color="#e7000b" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Authentication (OTP)</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats?.authentication.usage?.toLocaleString()} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats?.authentication.count}
              </Text>
            </Flex>
          </CardBody>
        </Card>

        <Card bg="green.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="green.200" borderStyle="solid">
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuCreditCard} color="#00a63e" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Transaction</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats?.transaction.usage?.toLocaleString()} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats?.transaction.count}
              </Text>
            </Flex>
          </CardBody>
        </Card>

        <Card bg="blue.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="blue.200" borderStyle="solid" >
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuInfo} color="#155dfc" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Informational</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats?.information.usage?.toLocaleString()} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats?.information.count}
              </Text>
            </Flex>
          </CardBody>
        </Card>

        <Card bg="purple.50" boxShadow="sm" borderRadius="lg"  border={1} borderColor="purple.200" borderStyle="solid" >
          <CardBody py={5}>
            <Flex justify="space-between" align="flex-start">
              <Flex direction="column" flex="1">
                <Flex align="center" mb={1}>
                  <Icon as={LuTrendingUp} color="#9810fa" fontSize="18px" mr={2} />
                  <Text fontWeight="600" fontSize="14px" color="gray.800">Marketing</Text>
                </Flex>
                <Text fontSize="12px" color="gray.500" mb={0}>{stats.marketing.usage?.toLocaleString()} Total usage</Text>
                
              </Flex>
              <Text fontSize="32px" fontWeight="700" color="gray.800" lineHeight="1">
                {stats.marketing.count?.toLocaleString()}
              </Text>
            </Flex>
          </CardBody>
        </Card>
      </Grid>
    </div>
  );
};

export default TemplateManagerSstats